<div class="flex flex-col gap-1 relative">
    <label [for]="placeholder" class="text-xs font-medium" *ngIf="label">
      {{ label }}
      <span *ngIf="required" class="text-red-500">*</span>
    </label>
    <mat-radio-group 
      [formControl]="radioFormControl" 
      class="radio-group-wrapper" 
      [ngClass]="[bgClass, hasError ? 'error-outline':'']">
      <ng-container *ngFor="let option of options">
        <mat-radio-button 
          *ngIf="option.type !== 'hidden'" 
          [value]="option['value']" 
          [disabled]="readOnly || option.type === 'disabled'">
          {{ option.label }}
        </mat-radio-button>
      </ng-container>
    </mat-radio-group>
    <p class="text-red-600 text-xs absolute error-text">
      <ng-content #content></ng-content>
    </p>
  </div>
  